import styled from '@emotion/styled';
import { ShopTypes } from '~/lib/data-contract';
import { Text } from '~/shared/components/Text';

type Props = {
    status?: ShopTypes.InvoiceStatus | undefined;
};

export default function Status({ status }: Props) {
    if (!status) return null;

    return (
        <Container>
            <DeliveryIndicator isOpen={status.isOpen} />
            <StyledText>{status.description}</StyledText>
        </Container>
    );
}

export const DeliveryIndicator = styled('span', {
    shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>(({ isOpen, theme }) => ({
    display: 'inline-block',
    height: 6,
    width: 6,
    borderRadius: '50%',
    marginBottom: 2,
    marginRight: theme.space[2],
    backgroundColor: isOpen ? theme.colors.success : theme.colors.alert,
}));

export const StyledText = styled(Text)({
    whiteSpace: 'nowrap',
});

export const Container = styled.div({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
});
